import { Icon } from "@atoms";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@shadcn";
import { Info } from "lucide-react";

const colors = require("@theme/colors") as Record<string, any>;

export type CategoryCardTemplateProps = {
  icon: string;
  title: string;
  description: string[];
  isSelected: boolean;
  onToggle: () => void;
};

export const CategoryCardTemplate = ({
  icon,
  title,
  description,
  isSelected,
  onToggle
}: CategoryCardTemplateProps): JSX.Element => {
  return (
    <div 
      className={`p-4 rounded-lg border transition-all duration-200 cursor-pointer ${
        isSelected 
          ? 'border-brand-orange bg-primary-lightest shadow-md' 
          : 'border-gray-300 bg-white hover:border-gray-300 hover:shadow-sm'
      }`}
      onClick={onToggle}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center flex-1 min-w-0">
          {/* Selection Circle/Checkmark */}
          <div className="mr-3 flex-shrink-0">
            {isSelected ? (
              <Icon variant="checkCircleFilled" size={20} color={colors.primary.medium} />
            ) : (
              <div className="w-5 h-5 rounded-full border-2 border-gray-300"></div>
            )}
          </div>
          
          {/* Category Icon and Title */}
          <div className="flex items-center flex-1 min-w-0">
            <span className="text-2xl mr-3 flex-shrink-0">{icon}</span>
            <h3 className="text-sm font-medium text-gray-900 truncate">{title}</h3>
          </div>
        </div>
        
        {/* Info Icon */}
        <div className="ml-3 flex-shrink-0">
          <HoverCard>
            <HoverCardTrigger asChild>
              <button 
                className="text-gray-400 hover:text-gray-600 transition-colors"
                onClick={(e) => e.stopPropagation()}
              >
                <Info className="h-4 w-4" strokeWidth={1.75} />
              </button>
            </HoverCardTrigger>
            <HoverCardContent className="w-80 p-4 bg-white">
              <div className="space-y-2">
                <h4 className="font-semibold text-sm">{title}</h4>
                <div className="text-xs text-gray-600 space-y-1">
                  {description.map((item, index) => (
                    <div key={index} className="flex items-start">
                      <span className="text-gray-400 mr-2">•</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </HoverCardContent>
          </HoverCard>
        </div>
      </div>
    </div>
  );
}; 
